import { SUBJECTS } from '../../../../../apps/frontend/src/utils/strings.js';
import data from '../../../../../apps/frontend/src/pages/revision-notes/data.json';
import { useEffect, useState } from 'react';
import { Tab, TabsContainer } from '../../utils/SubjectTabs.jsx';
import PdfDownloadCard from './PdfDownloadCard.jsx';
import axios from 'axios';

export default function RevisionNotes({ packId }) {
  const subjects = [SUBJECTS.PHYSICS, SUBJECTS.CHEMISTRY, SUBJECTS.MATHEMATICS];
  const [notes, setNotes] = useState(null);
  const [currentSubject, setCurrentSubject] = useState(SUBJECTS.PHYSICS);
  const [isPurchased, setIsPurchased] = useState(null);

  const checkPurchase = async () => {
    const purchaseResponse = await axios.get(`/api/packs/${packId}/is-purchased`);
    const isPurchasedData = purchaseResponse?.data?.data?.isPurchased;
    if (!isPurchasedData) return false;
    setIsPurchased(isPurchasedData);
    return true;
  };

  useEffect(() => {
    if (!packId) return;
    const isPurchasedResponse = checkPurchase();
    if (!isPurchasedResponse) return;
    let subjects = [];
    data
      .filter((item) => item.subject === currentSubject.name)
      .forEach((item) => {
        subjects.push(item);
      });
    setNotes(subjects);
  }, [packId, currentSubject]);

  useEffect(() => {
    if (isPurchased === false) {
      navigate('/v2/home');
    }
  }, [isPurchased]);

  const handleSubjectChange = (subject) => {
    setCurrentSubject(subject);
  };

  return (
    <div>
      <div className="w-full overflow-x-auto">
        <TabsContainer color={currentSubject?.color}>
          {subjects?.map((tab) => (
            <Tab
              key={tab.name}
              isActive={currentSubject?.name === tab.name}
              color={currentSubject?.name === tab.name ? currentSubject?.color : 'var(--q3-neutral-light)'}
              tabColor={tab.color}
              bgColor="var(--q3-surface-dim)"
              onClick={() => handleSubjectChange(tab)}
            >
              {tab.icon && <img src={tab.icon} alt={tab.name} className="" />}
              <p className="mb-0">{tab.name}</p>
            </Tab>
          ))}
        </TabsContainer>
      </div>
      <div className="grid grid-cols-2 gap-5 py-5">
        {notes &&
          notes?.map((item) => (
            <PdfDownloadCard title={item.chapter} link={item.url} resourceType={'Revision Notes'} />
          ))}
      </div>
    </div>
  );
}
